import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

const styles = (theme) => ({
  card: {
    height: "100%",
  },
  list: {
    height: "100% !important",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  container: {
    minHeight: "100% !important",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  listSelect: {
    width: "50%",
  },
  or: {
    paddingTop: 20,
    paddingBottom: 15,
  },
  orAboveSelect: {
    paddingTop: 15,
    paddingBottom: 5,
  },
});
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};

export default function CoreFilter(WrappedElement) {
  return withStyles(styles)(
    class extends Component {
      constructor(props) {
        super(props);
        this.state = {
          filter: {},
          expanded: "basic",
        };
      }
      componentDidUpdate(_prevProps, prevState) {
        if (!areObjectsEqual(this.props.filter, _prevProps.filter) && 
            !areObjectsEqual(this.props.filter, this.state.filter)) {
          this.updateFiltersFromProps();
        } else if (!areObjectsEqual(this.props.filter, this.state.filter)) {
          this.props.onFilterChange &&
            this.props.onFilterChange(this.state.filter);
        }
      }
      componentDidMount() {
        this.updateFiltersFromProps();
      }

      componentWillReceiveProps(newProps) {
        if (!areObjectsEqual(newProps.filter, this.state.filter)) {
          this.props.defaultFilter
            ? this.setState({
                filter: areObjectsEqual(
                  newProps.filter,
                  this.props.defaultFilter
                )
                  ? this.props.defaultFilter
                  : newProps.filter,
              })
            : this.setState({ filter: newProps.filter });
        }
      }
      updateFiltersFromProps = () => {
        try {
          let filters = null;
          if (typeof this.props.filter === "object") {
            filters = this.props.filter;
          } else {
            filters = JSON.parse(this.props.filter);
          }
          this.setState({ filter: filters });
        } catch (x) {
          alert(x);
        }
      };

      isDefaultFilter = (key, value) => {
        return (
          this.props.defaultFilter &&
          this.props.defaultFilter.hasOwnProperty(key) &&
          areObjectsEqual(value, this.props.defaultFilter[key])
        );
      };

      isFilterSet = (key) => {
        let isSet = false;
        if (
          !this.props.filter ||
          !this.props.filter.hasOwnProperty(key) ||
          this.isDefaultFilter(key, this.props.filter[key])
        ) {
          return false;
        }
        if (this.props.filter.hasOwnProperty(key)) {
          let type = typeof this.props.filter[key];
          let value = this.props.filter[key];
          if (type === "object") {
            if (moment.isMoment(value) || moment.isDate(value)) {
              isSet = true;
            } else if (
              key === "taxonomy" &&
              value &&
              value.length > 0 &&
              !areObjectsEqual(value, this.props.taxonomyNodeLookup)
            ) {
              isSet = true;
            } else if (value && value.length > 0) {
              if (
                key !== "taxonomy" ||
                (key === "taxonomy" &&
                  !areObjectsEqual(value, this.props.taxonomyNodeLookup))
              ) {
                isSet = true;
              }
            }
          } else if (type === "string" && value.trim().length > 0) {
            isSet = true;
          } else if (type === "number") {
            isSet = true;
          } else if (type === "boolean") {
            isSet = value === true;
          }
        }
        return isSet;
      };

      handleExpansionPanelChange = (panel) => (_event, expanded) => {
        this.setState({
          expanded: expanded ? panel : false,
        });
      };

      handleSortChange = (e) => {
        this.setState({
          filter: {
            ...this.state.filter,
            sort: e.target.value,
          },
        });
      };

      toggleSortDirection = () => {
        this.setState((prev) => {
          if (prev.filter.sortDirection === "ASC") {
            return { filter: { ...this.state.filter, sortDirection: "DESC" } };
          }
          return { filter: { ...this.state.filter, sortDirection: "ASC" } };
        });
      };

      handleTextFieldChange = (name) => (event) => {
        if (event.target.value.trim().length > 0) {
          this.setState({
            filter: {
              ...this.state.filter,
              [name]: event.target.value,
            },
          });
        } else {
          let newFilter = { ...this.state.filter };
          delete newFilter[name];
          this.setState({
            filter: {
              ...newFilter,
            },
          });
        }
      };

      handleTextFieldChangeFromState = (name) => (value) => {
        if (value.trim().length > 0) {
          this.setState({
            filter: {
              ...this.state.filter,
              [name]: value,
            },
          });
        } else {
          let newFilter = { ...this.state.filter };
          delete newFilter[name];
          this.setState({
            filter: {
              ...newFilter,
            },
          });
        }
      };

      handleCheckboxChange = (name) => (event) => {
        this.setState({
          filter: {
            ...this.state.filter,
            [name]: event.target.checked,
          },
        });
      };

      handleDateChange = (name) => (e) => {
        if (e) {
          this.setState({
            filter: {
              ...this.state.filter,
              [name]: new Date(e.valueOf()),
            },
          });
        } else {
          let newFilter = { ...this.state.filter };
          delete newFilter[name];
          this.setState({
            filter: {
              ...newFilter,
            },
          });
        }
      };

      handleSelectChange = (event) => {
        this.setState({
          filter: {
            ...this.state.filter,
            [event.target.name]: event.target.value,
          },
        });
      };

      handleChange = (event) => {
        this.setState({
          filter: {
            ...this.props.filter,
            [event.target.name]: event.target.value,
          },
        });
      };

      setTaxonomy = (e) => {
        let filter = null;
        if (
          e.filter(
            (ele) => ele.type === "taxonomy" && ele.parentList.length === 0
          ).length === 0
        ) {
          // the root node is not present so a filter is set...
          filter = {
            ...this.state.filter,
            taxonomy: this.prepareTaxonomyNodes(e),
          };
          this.setState({
            filter: filter,
          });
        } else {
          // the root node is present so remove any filter as this is treated as all knowledge selected
          filter = { ...this.state.filter };
          delete filter.taxonomy;
          this.setState({
            filter: {
              ...filter,
            },
          });
        }
        // filter.taxonomy &&
        //   this.props.setTaxonomyTest &&
        //   this.props.setTaxonomyTest(filter.taxonomy);
      };
      prepareTaxonomyNodes = (taxonomyFilter) => {
        //Create a list of TaxonomySelections (taxonomies or communities)

        //filter taxonomies to only include those whose parent is not present (otherwise they are included implicitly)
        let taxonomies = taxonomyFilter.filter(
          (ele) => ele.type === "taxonomy" && ele.children.length > 0
        );

        //get all the topic nodes and filter any whose parents are in the list of taxonomies and filter out any duplicates
        let topics = taxonomyFilter
          .filter((ele) => ele.type === "topic")
          .filter((ele) => {
            return (
              ele.type === "topic" &&
              ele.parentList &&
              ele.parentList.length > 0 &&
              taxonomies
                .map((t) => t.id)
                .indexOf(ele.parentList[ele.parentList.length - 1]) === -1
            );
          })
          .filter((topic, index, topicArray) => {
            const _topic = JSON.stringify(topic);
            return (
              index ===
              topicArray.findIndex((obj) => {
                return JSON.stringify(obj) === _topic;
              })
            );
          });

        if (topics.length > 0) {
          topics = topics
            .filter(
              (topic) =>
                taxonomies.map((ele) => ele.id).indexOf(topic.id) === -1
            )
            .map((ele) => {
              return {
                id: ele.object ? ele.object[ele.type + "Id"] : ele.id,
                type: ele.type,
                parentList: ele.parentList,
              };
            });
        }
        //now process the taxonomies and put the nodes highest up the list into a filtered list
        let filteredTaxonomies = [];
        let sorted = taxonomies.sort((a, b) => {
          return a.parentList.length > b.parentList.length
            ? 1
            : a.parentList.length < b.parentList.length
              ? -1
              : 0;
        });
        sorted.forEach(
          (tax) =>
            taxonomies
              .map((ele) => ele.id)
              .indexOf(tax.parentList[tax.parentList.length - 1]) === -1 &&
            filteredTaxonomies.push(tax)
        );
        let filtered =
          topics &&
          topics.concat(
            filteredTaxonomies.map((ele) => {
              return {
                id: ele.id,
                type: ele.type,
                // parentList: ele.parentList,
                // children: ele.children,
              };
            })
          );
        return filtered;
      };
      getTaxonomy = (filter, taxonomyNodeLookup) => {
        let filters = filter
          ? filter.length > 0
            ? this.reHydrateTaxonomy(filter)
            : this.props.taxonomyNodeLookup
          : this.props.taxonomyNodeLookup;
        return filters;
      };
      reHydrateTaxonomy = (filter) => {
        // taxonomy selections saved for portlets do not contain all taxonomy nodes,
        // only those highest up in the tree that are selected add back the children
        let hydrated = [];
        !areObjectsEqual(filter, this.props.taxonomyNodeLookup) &&
          filter.filter((f) => f.type === "taxonomy").forEach((t) => {
            hydrated = hydrated.concat(
              this.getChildren(
                this.props.taxonomyNodeLookup.filter(
                  (l) => l.id === t.id && l.type === "taxonomy"
                )[0]
              )
            );
          });
        return filter.concat(hydrated);
      };
      getChildren = (node) => {
        let childNodes = []
        if (node) {
          childNodes = node.children ? [...node.children] : [];
          node.children.forEach(
            (c) => c.children && childNodes.push(...this.getChildren(c))
          );
        }
        return childNodes;
      };
      handleUserAutosuggest = (name) => (e) => {
        this.setState({
          filter: {
            ...this.state.filter,
            [name]: e.userId,
          },
        });
      };

      addChip = (key, chip) => {
        this.setState({
          filter: {
            ...this.state.filter,
            [key]: this.state.filter[key]
              ? [...this.state.filter[key], chip]
              : [chip],
          },
        });
      };

      deleteChip = (key, chip) => {
        let filtered = this.state.filter[key].filter((i) => i !== chip);
        this.setState({
          filter: {
            ...this.state.filter,
            [key]: [...filtered],
          },
        });
      };

      onChangeChips = (key, chips) => {
        this.setState({
          filter: {
            ...this.state.filter,
            [key]: [...chips],
          },
        });
      };

      handleDisplayAllListsChange = (e) => {
        this.setState({
          filter: {
            ...this.state.filter,
            listDisplayAllLists: e.target.checked,
          },
        });
      };

      handleNewListChange = (e) => {
        this.setState({
          filter: {
            ...this.state.filter,
            createNewList: e.target.checked,
          },
        });
      };

      handleListChange = (e) => {
        this.setState({
          filter: {
            ...this.state.filter,
            listID: e.target.value,
          },
        });
      };
      removeCreatedBy = () => {
        this.setState({
          filter: {
            ...this.state.filter,
            createdBy: "",
          },
        });
      };

      render() {
        const { classes } = this.props;
        return this.state.filter !== null ? (
          <WrappedElement
            {...this.props}
            expanded={this.state.expanded}
            classes={classes}
            filter={this.props.filter}
            handleExpansionPanelChange={this.handleExpansionPanelChange}
            handleSortChange={this.handleSortChange}
            handleTextFieldChange={this.handleTextFieldChange}
            handleTextFieldChangeFromState={this.handleTextFieldChangeFromState}
            handleSelectChange={this.handleSelectChange}
            handleDateChange={this.handleDateChange}
            handleCheckboxChange={this.handleCheckboxChange}
            toggleSortDirection={this.toggleSortDirection}
            handleUserAutosuggest={this.handleUserAutosuggest}
            setTaxonomy={this.setTaxonomy}
            getTaxonomy={this.getTaxonomy}
            addChip={this.addChip}
            deleteChip={this.deleteChip}
            toggleSortOrder={this.toggleSortOrder}
            handleChange={this.handleChange}
            handleListChange={this.handleListChange}
            handleNewListChange={this.handleNewListChange}
            handleDisplayAllListsChange={this.handleDisplayAllListsChange}
            removeCreatedBy={this.removeCreatedBy}
            onChangeChips={this.onChangeChips}
            isFilterSet={this.isFilterSet}
          />
        ) : (
          <></>
        );
      }
    }
  );
}
